import type {
  PaywallPrice,
  PaywallPriceScenario,
} from "@circle-react/types/PaywallPrice";

import type { ConversionTrackingItem } from "@/react/api/conversionTrackingApi";

import { getPaywallPriceAmount } from "./paywallPrices";

// PAY-404 -- `begin_checkout`/`items[]` use the plan's bare nominal amount
// (no live preview available that early -- see `CheckoutSessionContext.tsx`).
// `add_payment_info` does NOT use this -- it reports `amountDue` directly
// (see `PaymentElement.tsx`), since `value` should reflect what will
// actually be charged, not the plan's nominal recurring price.
export const getConversionTrackingPriceValue = (price: PaywallPrice): number =>
  getPaywallPriceAmount(price);

// PAY-404 -- wraps the single selected price as a one-element `items` array
// (`begin_checkout` only -- see `ConversionTrackingItem`).
export const getConversionTrackingItems = (
  price: PaywallPrice,
): ConversionTrackingItem[] => [
  {
    item_id: price.id,
    price: getConversionTrackingPriceValue(price),
    quantity: 1,
  },
];

// PAY-404 -- the two scenarios that actually start with a trial. The FE
// reports `trial_days` (add_payment_info only) for exactly these -- omitted
// for `upfront_then_trial_then_value`, `upfront_then_value`, and `value`.
const TRIAL_FIRST_SCENARIOS: PaywallPriceScenario[] = [
  "trial_then_value",
  "trial_then_upfront_then_value",
];

export const getConversionTrackingTrialDays = (
  price: PaywallPrice,
): number | undefined =>
  TRIAL_FIRST_SCENARIOS.includes(price.scenario) ? price.trial_days : undefined;
